<template>
	<form class="modal-form evaluate-loan"  v-if="preScores">
		<div v-if="!promo" class="evaluate-loan__top">
			<h3 class="evaluate-loan__title">Закажите онлайн-оценку</h3>
			<ul v-if="false" class="page-section__tabs evaluate-loan__tabs" @touchmove.stop.capture>
				<li class="page-section__tabs-item">
					<a
						class="page-section__tabs-link"
						@click.prevent="viewMode = 'full'"
						:class="{active: viewMode === 'full'}"
						href="#"
					>Подробная онлайн-оценка</a>
				</li>
				<li class="page-section__tabs-item">
					<a
						class="page-section__tabs-link"
						@click.prevent="viewMode = 'short'"
						:class="{active: viewMode === 'short'}"
						href="#"
					>Быстрая оценка</a>
				</li>
			</ul>
			<ol class="evaluate-loan__instruction">
				<li class="evaluate-loan__instruction-item">Укажите желаемую сумму и срок займа.</li>
				<li class="evaluate-loan__instruction-item">Укажите вид и характеристики залога.</li>
				<li class="evaluate-loan__instruction-item">После заполнения всех параметров появится
					предварительная оценка. Для более точной оценки и получения ставки 0,3% отправьте заявку нашим
					специалистам.
				</li>
			</ol>
		</div>
		<div class="evaluate-loan__info">
			<button class="btn color evaluate-loan__info-btn" @click.prevent="onOpenPhotoSearchModal">Новые возможности онлайн оценки</button>
			<ol class="evaluate-loan__instruction">
				<li class="evaluate-loan__instruction-item">Подгрузите фото комнаты в форму оценки.</li>
				<li class="evaluate-loan__instruction-item">Мы с помощью ИИ оценим все предметы подлежащие для сдачи в ломбард.</li>
				<li class="evaluate-loan__instruction-item">Выберите нужный залог и оформите онлайн оценку.</li>
			</ol>
		</div>
		<ul class="evaluate-loan__steps">
			<li class="e-step" :class="{'e-step--selected' : this.getEstimateFormTouch('max_loan')}">
				<div class="e-step__top">
					<div class="e-step__top-number"></div>
					<div class="e-step__top-title">Желаемая сумма займа</div>
					<div v-if="this.getEstimateFormTouch('max_loan')" class="e-step__top-value">
						{{ Number(max_loan).toLocaleString('ru-RU') }} руб.
					</div>
				</div>
				<div
					v-if="this.getEstimateFormTouch('max_loan')"
					class="e-step__edit"
					@click.prevent="setEstimateFormTouch({key: 'max_loan', value: false})"
				>Редактировать
				</div>
				<div v-else class="e-step__content">
					<div class="range-block">
						<div class="default-input">
							<label class="default-input__label">Мне нужно</label>
							<div class="default-input__input">
								<input v-model="max_loan" type="text" v-mask="{
                                                name: 'currency',
                                                options: {
                                                groupSeparator: ' ',
                                                autoGroup: true,
                                                suffix: ' руб.',
                                                prefix: 'до ',
                                                rightAlign: false,
                                                placeholder: '_',
                                                digits: 0,
                                                min: this.preScores['loan']['min'],
                                                autoUnmask: true
                                                }}" :placeholder="`до ${preScores['loan']['max']} руб.`">
							</div>
						</div>
						<Slider :tooltips="false" :lazy="false" v-model="max_loan"
								:min="preScores['loan']['min'] - 1" :max="preScores['loan']['max']"/>
					</div>
				</div>
			</li>
			<li class="e-step" :class="{'e-step--selected' : this.getEstimateFormTouch('max_term')}">
				<div class="e-step__top">
					<div class="e-step__top-number"></div>
					<div class="e-step__top-title">Желаемый срок займа</div>
					<div v-if="this.getEstimateFormTouch('max_term')" class="e-step__top-value">до
						{{ max_term }} {{ max_term[max_term.length - 1] == 1 ? 'дня' : 'дней' }}
					</div>
				</div>
				<div
					v-if="this.getEstimateFormTouch('max_term')"
					@click.prevent="setEstimateFormTouch({key: 'max_term', value: false})"
					class="e-step__edit"
				>Редактировать
				</div>
				<div v-else class="e-step__content">
					<div class="range-block">
						<div class="default-input">
							<label class="default-input__label">На срок</label>
							<div class="default-input__input">
								<input
									v-model="max_term"
									type="text"
									ref="termSum"
									:placeholder="`до ${preScores['term']['max']} дней`" v-mask="{
											name: 'numeric',
											options: {
												prefix: 'до ',
												suffix: ' дней',
												rightAlign: false,
												placeholder: '_',
												digits: 0,
												min: this.preScores['term']['min'],
												autoUnmask: true,
											}
										}">
							</div>
						</div>
						<Slider :tooltips="false" :lazy="false" v-model="max_term"
								:min="preScores['term']['min'] - 1" :max="preScores['term']['max']"/>
					</div>
				</div>
			</li>
			<li class="e-step" v-if="viewMode === 'full'"
				:class="{'e-step--selected' : this.getEstimateFormTouch('accept'), 'e-step--1' : !this.getEstimateFormTouch('accept')}">
				<div class="e-step__top">
					<div class="e-step__top-number"></div>
					<div class="e-step__top-title">Предмет залога<span class="red-text">*</span></div>
					<div v-if="this.getEstimateFormTouch('accept')" class="e-step__top-value">
						{{ preScores['accept_types'].find(i => String(i.id) === accept).name }}
					</div>
				</div>
				<div
					v-if="this.getEstimateFormTouch('accept')"
					class="e-step__edit"
					@click.prevent="setEstimateFormTouch({key: 'accept', value: false})"
				>Редактировать
				</div>
				<div v-else class="e-step__content">
					<div v-if="false" class="l-search">
						<div class="default-input">
							<div class="default-input__input">
								<input v-model="searchScores" placeholder="Начните вводить название">
							</div>
							<div
								class="default-input__tooltip"
								:class="{'active' : preScoresData?.length > 0 && searchScores?.length && !accept}"
							>
								<div
									v-for="item in preScoresData"
									class="default-input__tooltip-item"
									:key="item.id"
									@click="accept = String(item.id)"
								>{{ item.name }}
								</div>
							</div>
							<div class="default-input__search"></div>
						</div>
					</div>
					<div class="l-property">
						<div class="l-property__list" v-if="preScores">
							<div
								class="l-property__item"
								v-for="(item, index) in preScoresData"
								:class="[{active :  +accept === +item.id},{hide : !showMore && index > 5}]"
								:key="item.id"
								@click="accept = String(item.id)"
							>
								<div class="l-property__wrap">
									<div class="l-property__item-img">
										<img :src="item.icon" loading="lazy" alt="">
									</div>
									<div class="l-property__item-title">{{ item.name }}</div>
								</div>
							</div>
							<div
								v-if="showMore"
								class="l-property__item"
								:class="{active : isCategoryNotFoundSelected}"
								@click.prevent="onSelectCategoryNotFound"
							>
								<div class="l-property__wrap">
									<div class="l-property__item-title">Не нашли нужную категорию?</div>
								</div>
							</div>
						</div>

						<div class="l-property__empty" v-if="preScoresData.length === 0">Предметов не найдено</div>
						<div
							class="show-more l-property__more"
							v-if="preScoresData.length > 6"
							@click="showMore = true" :class="{open : showMore}"
						>Показать еще</div>
					</div>
				</div>
			</li>
			<li
				class="e-step e-step--1"
				v-if="!isCategoryNotFoundSelected && ((accept && viewMode === 'full') || viewMode === 'short')"
			>
				<div class="e-step__top">
					<div class="e-step__top-number"></div>
					<div class="e-step__top-title">Выберите предмет залога<span class="red-text">*</span>
					</div>
				</div>
				<div class="e-step__content">
					<div class="l-data">
						<div v-if="acceptItems(accept).length > 6" class="l-sample wide">
							<div class="search-input">
								<input v-model="itemsSearch" class="search-input__input" placeholder="Поиск" type="text">
								<button class="search-input__btn"></button>
							</div>
						</div>
						<div class="l-sample wide">
							<div v-if="filteredItems.length" class="l-sample__list">
								<div
									v-for="item in shownItems"
									:key="item.id"
									class="l-sample__list-item"
									:class="{ active : +item_id === +item.id }"
									@click="item_id = item.id"
								>
									{{ item.name }}
								</div>
								<div v-if="filteredItems.length > 6" class="l-sample__actions">
									<button v-if="itemsShowMore" type="button" class="show-more show-more--less" @click.prevent="itemsShowMore = false">Скрыть</button>
									<button v-else  type="button" class="show-more" @click.prevent="itemsShowMore = true">Показать еще</button>
								</div>
							</div>
							<div v-else>Предметов не найдено</div>
						</div>
					</div>
				</div>
			</li>
			<li class="e-step" :class="{'e-step--selected' : this.getEstimateFormTouch('photos')}">
				<div class="e-step__top">
					<div class="e-step__top-number"></div>
					<div class="e-step__top-title">
						<span>{{ this.preScores['fieldNames']?.photoInput || 'Сделайте фото для оценки' }}</span>
						<span class="red-text">*</span>

						<div
							class="l-tooltip"
							:class="{'l-tooltip--big' : helpInfo('help_image')}"
							v-if="viewMode === 'full' && helpInfo('help')"
						>
							<div class="l-tooltip__icon"></div>
							<div class="l-tooltip__block">
								<div class="l-tooltip__text" v-html="helpInfo('help')"></div>
								<div class="l-tooltip__img" v-if="helpInfo('help_image')">
									<img :src="helpInfo('help_image')">
								</div>
							</div>
						</div>
					</div>
					<div v-if="this.getEstimateFormTouch('photos')" class="e-step__top-photo">
						<div class="preview">
							<div
								class="preview-img"
								v-for="(photo,index) in photos"
								:key="index"
								:style="`background-image: url(${previewUrl(photo)})`"
							>
							</div>
						</div>
					</div>
				</div>
				<div
					v-if="this.getEstimateFormTouch('photos')"
					@click.prevent="setEstimateFormTouch({key: 'photos', value: false})"
					class="e-step__edit"
				>Редактировать
				</div>
				<div v-else class="e-step__content">
					<div class="l-step__file">
						<div class="default-file" :class="{'default-file--error' : photos.length < 1 && emptyFields}">
							<div class="default-file__input">
								<div class="default-file__input-title">Прикрепить фото</div>
								<input
									class="default-file__input-input" ref="photoInput"
									:disabled="photos.length >= preScores['files']['max_count']"
									@change="setFiles" multiple :accept="preScores['file_ext']" type="file"
								>
							</div>
						</div>
					</div>
					<div class="l-step__preview">
						<div class="preview">
							<div
								class="preview-img"
								v-for="(photo,index) in photos"
								:key="index"
								:style="`background-image: url(${previewUrl(photo)})`"
							>
								<span @click.stop="photos = photos.filter((item,ind) => ind !== index)"></span>
							</div>
							<div
								class="preview-add"
								v-if="photos.length && photos.length < preScores['files']['max_count']"
								@click="$refs.photoInput.click()"
							></div>
						</div>
					</div>
				</div>
			</li>
			<li class="e-step e-step--1"
				v-if="(accept && viewMode === 'full') || viewMode === 'short'">
				<div class="e-step__top">
					<div class="e-step__top-number"></div>
					<div class="e-step__top-title">Введите данные предмета залога<span class="red-text">*</span>
						<template v-if="item_id && viewMode === 'full'">
							<div
								class="l-tooltip"
								v-if="acceptItemData(accept ,item_id) && acceptItemData(accept,item_id).note"
							>
								<div class="l-tooltip__icon"></div>
								<div class="l-tooltip__block">
									<div class="l-tooltip__text">{{
											acceptItemData(accept, item_id).note
										}}
									</div>
									<div class="l-tooltip__img" v-if="accept === '1'">
										<img
											src="local/templates/.default/img/personal/tooltip-img.png"
											loading="lazy"
											alt=""
										>
									</div>
								</div>
							</div>
						</template>
					</div>
				</div>
				<div class="e-step__content">
					<div class="l-data" v-if="accept && viewMode === 'full'">
						<template v-if="item_id && acceptItemData(accept,item_id)">
							<template  v-if="acceptItemData(accept ,item_id).is_def_calc">
								<div class="default-input">
									<label class="default-input__label">Укажите бренд</label>
									<div
										class="default-input__input"
										:class="{'default-input__input--error' : getItemParamsKey('brand') === '' && emptyFields}">
										<input
											:value="getItemParamsKey('brand')"
											@input="setItemParamsKey({key: 'brand', value: $event.target.value})"
											type="text" placeholder="Введите название"
										>
									</div>
								</div>

								<div class="default-input">
									<label class="default-input__label">Укажите модель</label>
									<div
										class="default-input__input"
										:class="{'default-input__input--error' : getItemParamsKey('model') === '' && emptyFields}"
									>
										<input
											:value="getItemParamsKey('model')"
											@input="setItemParamsKey({key: 'model', value: $event.target.value})"
											type="text" placeholder="Введите название"
										>
									</div>
								</div>

								<template v-if="preScores['default_selects']">
									<div class="default-input">
										<label class="default-input__label">Укажите состояние</label>
										<div class="default-input__select">
											<Multiselect
												:label="'name'"
												:value="getItemParamsKey('condition')"
												@change="setItemParamsKey({key: 'condition', value: $event})"
												@click.stop @mousedown.stop :value-prop="'id'"
												:placeholder="'Выберите состояние'"
												:options="preScores['default_selects'].conditions">
												<template #placeholder>
													<div class="multiselect-placeholder">
														<span>Выберите состояние</span>
													</div>
												</template>
											</Multiselect>
										</div>
									</div>
								</template>

								<div class="l-sample">
									<div class="l-sample__title">Наличие чека</div>
									<div class="l-sample__list">
										<div
											class="l-sample__list-item"
											@click="setItemParamsKey({key: 'has_receipt', value: '1'})"
											:class="{ active : getItemParamsKey('has_receipt') === '1' }"
										>
											Да
										</div>
										<div
											class="l-sample__list-item"
											@click="setItemParamsKey({key: 'has_receipt', value: '0'})"
											:class="{ active : getItemParamsKey('has_receipt') === '0' }"
										>
											Нет
										</div>
									</div>
								</div>

								<div class="default-input wide">
									<label class="default-input__label">Укажите характеристики</label>
									<div
										class="default-input__input"
										:class="{'default-input__input--error' : getItemParamsKey('description') === '' && emptyFields}"
									>
										<textarea
											v-respHeight :value="getItemParamsKey('description')"
											@input="setItemParamsKey({key: 'description', value: $event.target.value})"
											:placeholder="'Опишите предмет залога'"
											tabindex="0"
										></textarea>
									</div>
								</div>
							</template>
							<template v-else>
								<template v-for="item in currentItemFields" :key="item.xml_id">

									<div v-if="item.type_field === 'input' && item.xml_id === 'weight'" class="l-data">
										<div class="l-sample wide">
											<div class="default-checkbox">
												<input
													:checked="getEstimateFormFlag('showWeightInput')"
													type="checkbox"
													id="weight-checkbox"
													name="weight-checkbox"
													class="default-checkbox__input"
												/>
												<label
													class="default-checkbox__label"
													@click="onToggleShowWeightInput"
												>Ввести вес с бирки</label>
											</div>
										</div>

										<div class="l-sample">
											<div v-if="getEstimateFormFlag('showWeightInput')" class="default-input">
											<label class="default-input__label">{{ item.title }}</label>
											<div
												class="default-input__input"
												:class="{'default-input__input--error' : getItemParamsKey(item.xml_id) === '' && emptyFields}"
											>
												<input
													:value="getItemParamsKey(item.xml_id)"
													v-mask="item.type_data === 'float' || item.type_data === 'int' ? 'numeric' : ''"
													@input="setItemParamsKey({key: item.xml_id, value: $event.target.value})"
													type="text"
													:placeholder="item.placeholder">
											</div>
										</div>
										
										</div>
									</div>
									<template v-else-if="item.type_field === 'input'">
										<div
											class="l-sample"
											:class="{wide: isCategoryNotFoundSelected}"
											v-if="isInputAllowed(item)"
										>
											<div class="default-input">
												<label class="default-input__label">{{ item.title }} {{item.is_required ? '*' : ''}}</label>
												<div
													class="default-input__input"
													:class="{'default-input__input--error' : ((item.is_required && getItemParamsKey(item.xml_id) === '') && emptyFields) || (item.xml_id === 'description' && (getItemParamsKey(item.xml_id).length < 10 && emptyFields))}"
												>
													<input
														:value="getItemParamsKey(item.xml_id)"
														v-mask="item.type_data === 'float' || item.type_data === 'int' ? 'numeric' : item.xml_id === 'imei' ? '999999999999999' : ''"
														@input="setItemParamsKey({key: item.xml_id, value: $event.target.value})"
														type="text"
														:placeholder="item.placeholder"
														>
														
													</div>
													<template v-if="item.xml_id !== 'description'">
														<span v-if="item.is_required && getItemParamsKey(item.xml_id) === '' && emptyFields"  class="default-input__error">Поле обязательно для заполнения</span>
													</template>
													<span class="default-input__error" v-else-if="item.is_required &&  (getItemParamsKey(item.xml_id).length < 10 && emptyFields)"> В описании должно быть не менее 10 символов</span>
											</div>
										</div>
									</template>
									<template v-else-if="item.type_field === 'select'">
										<div v-if="item.xml_id !== 'model_list'"  class="default-input">
											<label class="default-input__label">{{ item.title }} {{item.is_required ? '*' : ''}}</label>
											<div class="default-select" :class="{'default-select--error' : (item.is_required && getItemParamsKey(item.xml_id) === '') && emptyFields}">
												<Multiselect
													:value="getItemParamsKey(item.xml_id)"
													@change="onSelectValue(item, $event)"
													@click.stop @mousedown.stop
													label="name"
													value-prop="value"
													:placeholder="item.placeholder ? item.placeholder : 'Выберите значение'"
													:options="item.values"
													:searchable="true"
													:mode="item.is_multiple ? 'multiple' : 'single'"
													:hideSelected="false"
													:multipleLabel="(value) => item.is_multiple ? 'Выбрано опций ' + value.length : ''"
													:closeOnSelect="item.is_multiple ? false : true"
													no-results-text="Ничего не найдено"
													no-options-text="Нет вариантов для выбора"
												>
													<template #placeholder>
														<div class="multiselect-placeholder">
															<span>{{ item.placeholder || 'Выберите значение' }}</span>
														</div>
													</template>
												</Multiselect>
												<span class="default-input__error active" v-if="item.is_required && getItemParamsKey(item.xml_id) === '' && emptyFields">Поле обязательно для заполнения</span>
											</div>									
										</div>
										<!-- Костыль для выбора моделей -->
										<div v-else-if="getItemParamsKey('manufacturer_id') && getItemParamsKey('manufacturer_id') !== 'Другое'"  class="default-input">
											<label class="default-input__label">{{ item.title }}</label>
											<div class="default-select" :class="{'default-select--error' : getItemParamsKey(item.xml_id) === '' && emptyFields}">
												<Multiselect
													:label="'name'"
													:value="getItemParamsKey(item.xml_id)"
													@change="setItemParamsKey({key: item.xml_id, value: $event})"
													@click.stop @mousedown.stop
													:value-prop="'value'"
													:placeholder="item.placeholder ? item.placeholder : 'Выберите значение'"
													:options="models"
													:searchable="true"
													:mode="item.is_multiple ? 'multiple' : 'single'"
													:hideSelected="false"
													:multipleLabel="(value) => item.is_multiple ? 'Выбрано опций ' + value.length : ''"
													:closeOnSelect="item.is_multiple ? false : true"
												>
													<template #placeholder>
														<div class="multiselect-placeholder">
															<span>Рекламная модель</span>
														</div>
													</template>
												</Multiselect>
											</div>
										</div>

									</template>

									<template
										v-else-if="item.type_field === 'checkbox' && item.xml_id !== 'color'">
										<div class="l-sample wide">
											<div class="l-sample__title">{{ item.title }}</div>
											<div class="l-sample__list">
												<div
													v-for="(value,index) in item.values"
													:key="index"
													class="l-sample__list-item"
													@click="setItemParamsKey({key: item.xml_id, value: value.value})"
													:class="{ active : getItemParamsKey(item.xml_id) === value.value }"
												>
													{{ value.name }}
												</div>
											</div>
										</div>
									</template>

									<template
										v-else-if="item.type_field === 'checkbox' && item.xml_id === 'color'">
										<div class="l-sample wide">
											<div class="l-sample__title">{{ item.title }}</div>
											<div class="l-sample__list">
												<div
													v-for="(value,index) in item.values"
													:key="index"
													class="l-sample__list-item"
													@click="setItemParamsKey({key: item.xml_id, value: value.value})"
													:class="[{ active : getItemParamsKey(item.xml_id) === value.value }, {disabled : !getItemParamsKey('sample') || !value.samples_available.includes(getItemParamsKey('sample'))}]">
													{{ value.name }}
												</div>
											</div>
										</div>
									</template>
								</template>
							</template>
						</template>
					</div>
				</div>
			</li>
			<li class="e-step e-step--1" ref="contactBlock">
				<div class="e-step__top">
					<div class="e-step__top-number"></div>
					<div class="e-step__top-title">Введите ваши данные для связи<span
						class="red-text">*</span></div>
				</div>
				<div class="e-step__content">
					<div class="l-data">
						<div class="default-input">
							<label class="default-input__label">Введите ваше имя</label>
							<div
								class="default-input__input"
								:class="{'default-input__input--error' : v$.name.$errors.length}"
							>
								<input v-model="name" type="text" placeholder="Иванов Иван">
							</div>
							<div v-if="v$.name.$errors.length" class="default-input__error">
								<span v-for="(error, index) in v$.name.$errors" :key="index">{{ error.$message }}</span>
							</div>
						</div>

						<div class="default-input">
							<label class="default-input__label">Введите ваш телефон</label>
							<div
								class="default-input__input"
								:class="{'default-input__input--error' : v$.phone.$errors.length}"
							>
								<input
									v-mask="'+7 (999) 999 99 99'"
									v-model="phone"
									type="tel"
									ref="inputPhone"
									placeholder="+7 (351) 900 02 02"
								>
							</div>
							<div v-if="v$.phone.$errors.length" class="default-input__error"><span
								v-for="(error, index) in v$.phone.$errors" :key="index">{{ error.$message }}</span>
							</div>
						</div>

						<div class="default-input">
							<label class="default-input__label">Введите ваш email</label>
							<div
								class="default-input__input"
								:class="{'default-input__input--error' : v$.email.$errors.length}"
							>
								<input v-model="email" type="email" ref="inputEmail" placeholder="mail@mail.ru">
							</div>
							<div v-if="v$.email.$errors.length" class="default-input__error"><span
								v-for="(error, index) in v$.email.$errors" :key="index">{{ error.$message }}</span>
							</div>
						</div>

						<div class="default-input">
							<label class="default-input__label">Выберите ваш город</label>
							<div class="default-select" :class="{'default-select--error' : v$.city.$errors.length}">
								<Multiselect
									ref="multiselect"
									v-model="city"
									openDirection="top"
									:placeholder="'Выберите город'"
									noResultsText="Ничего не найдено"
									:searchable="true"
									:can-clear="false"
									:can-deselect="false"
									:label="'name'"
									:value-prop="'id'"
									:options="citiesList"
									@click.stop @mousedown.stop
								>
									<template #placeholder>
										<div class="multiselect-placeholder"><span>Выберите город</span>
										</div>
									</template>
								</Multiselect>
							</div>
							<div v-if="v$.city.$errors.length" class="default-input__error">
								<span v-for="(error, index) in v$.city.$errors" :key="index">{{ error.$message }}</span>
							</div>
						</div>

						<div class="l-sample" v-if="courierAvailable">
							<div class="l-sample__title">Заказать выезд специалиста на дом (услуга бесплатна и доступна
								при стоимости <br> залога от 5 000р.)
							</div>
							<ul class="l-sample__list">
								<li class="l-sample__list-item" @click="courier_required = true"
									:class="{ active : courier_required }">Да
								</li>
								<li class="l-sample__list-item" @click="courier_required = false"
									:class="{ active : courier_required == false }">Нет
								</li>
							</ul>
						</div>

						<div v-if="communicationTypes" class="l-data__row">
							<div class="l-checkboxes">
								<span class="l-checkboxes__title">Выберите способ обратной связи</span>
								<div
									v-for="item in communicationTypes"
									:key="item.id" class="default-checkbox"
									:class="{'default-input__input--error' : v$.com_types.$errors.length}"
								>
									<input
										v-model="com_types"
										type="checkbox"
										:id="`ef-checkbox-${item.id}`"
										:value="item.id"
										class="default-checkbox__input"
									/>
									<label
										:for="`ef-checkbox-${item.id}`"
										class="default-checkbox__label"
									>{{ item.name || '' }}</label>
								</div>
								<div v-if="v$.com_types.$errors.length" class="default-input__error">
									<span>{{ v$.com_types.$errors[0].$message }}</span>
								</div>
							</div>
						</div>

					</div>
				</div>
			</li>
		</ul>
		<div class="evaluate-loan__submit">
			<div class="el-assessment">
				<div class="el-assessment__info"> 
					<div class="default-checkbox">
						<input hidden="" class="default-checkbox__input" id="checkbox-popup-estimate-form-advert-agreement" type="checkbox" name="advert-agreement" value="Y" required />
						<label class="default-checkbox__label" for="checkbox-popup-estimate-form-advert-agreement">
							<span>
								Я&nbsp;<a :href="documents['advertising-agreement']" target="_blank" >согласен на получение рекламы</a>
							</span>
						</label>
					</div>
				</div>
				<div class="el-assessment__btn" @mouseenter="highlightInputs">
					<button class="btn color shadow" @click.prevent="sendForm"
							:disabled="loading || !formCompleteStatus(viewMode)">Оставить заявку
					</button>
					<span class="el-assessment__required" v-if="!formCompleteStatus(viewMode)">Для подачи заявки необходимо заполнить все поля</span>
				</div>
				<div class="el-assessment__info">
					<p>
						Нажимая кнопку «Оставить заявку», вы даете информированное
						<a :href="documents['personal-data']" target="_blank">согласие на обработку персональных данных</a>
						в соответствии с <a :href="documents['policy']" target="_blank">Политикой обработки персональных данных потребителей</a>
					</p>
					<p><a :href="documents['effects-notion']" target="_blank">Уведомление о юридических последствиях
						отказа в предоставлении персональных данных или согласия на обработку</a></p>
					<p>Окончательная оценка и возможность оформления договора займа под залог указанного имущества
						возможна исключительно при детальном осмотре залогового имущества товароведом и
						подтверждения его технической исправности комплектности.</p>
					<br/>
				</div>
			</div>
		</div>
	</form>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import Slider from "@vueform/slider"
import Multiselect from "@vueform/multiselect";
import useVuelidate from '@vuelidate/core'
import {required, helpers, maxLength, email} from '@vuelidate/validators'

const {withMessage} = helpers
const CATEGORY_NOT_FOUND_ID = 'virtual_type';
const CATEGORY_NOT_FOUND_ITEM_ID = 'virtual_item';
export default {
	name: "PopupEstimateForm",
	emits: ['close'],
	components: {Slider, Multiselect},
	props: {
		promo: {
			type: Boolean,
			default: false
		}
	},
	setup() {
		return {
			v$: useVuelidate()
		}
	},
	data() {
		return {
			showMore: false,
			emptyFields: false,
			preScoreTimeout: null,
			loading: false,
			searchScores: null,
			itemsSearch: '',
			itemsShowMore: false,
			models: [],
		}
	},
	validations() {
		return {
			name: {
				required: withMessage('Необходимо указать имя', required),
				maxLength: withMessage('Максимальная длина поля 50 символов', maxLength(50)),
			},
			city: {
				required: withMessage('Необходимо указать город', required),
			},
			email: {
				required: withMessage('Необходимо указать email', required),
				email: withMessage('Введите корректный email', email),
			},
			phone: {
				required: withMessage('Необходимо указать телефон', required),
				maxLength: withMessage('Максимальная длина поля 50 символов', maxLength(50)),
			},

		}
	},
	async mounted() {
		this.$watch('max_term', (newValue) => {
			if (!this.$refs.termSum || !this.$refs.termSum.inputmask) return
			if (newValue[newValue.length - 1] == 1 && newValue != 11) {
				this.$refs.termSum.inputmask.option({
					suffix: ' дня'
				})
			} else {
				this.$refs.termSum.inputmask.option({
					suffix: ' дней'
				})
			}
		})

		this.$watch('completeFullStatus', (newValue) => {
			if (newValue) {
				this.loadPreScoreValues()
			}
		})
		this.$watch('getUserData', (userData) => {
			if (!userData) return
			this.setEstimateFormKey({key: 'name', value: `${userData.name} ${userData.last_name}`})
			this.setEstimateFormKey({key: 'email', value: userData.email})
			this.setEstimateFormKey({key: 'phone', value: userData.phone})
		}, {immediate: true})
	},
	computed: {
		viewMode: {
			get() {
				return this.getViewMode
			},
			set(value) {
				this.setViewMode(value)
				if (this.$refs.tabContainer && window.matchMedia("(max-width: 768px)").matches) {
					if (value === 'short') {
						this.$refs.tabContainer.scrollLeft = -100
					} else {
						this.$refs.tabContainer.scrollLeft = 100
					}
				}

				this.com_types = [];
			}
		},
		// Исключаем служенбый (не нашли нужную категорию)
		shownAcceptTypes() {
			return this.preScores.accept_types.filter(type => type.id !== CATEGORY_NOT_FOUND_ID)
		},
		preScoresData() {
			return this.searchScores ?
				this.shownAcceptTypes.filter(el => el.synonyms.some(synonym => synonym?.toLowerCase().includes(this.searchScores?.toLowerCase())))
				: this.shownAcceptTypes;
		},

		helpInfo() {
			return function (field) {
				const currentScore = this.preScoresData.find(obj => obj.id === Number(this.accept))
				if (!currentScore) return false

				return currentScore[field] || false
			}
		},


		communicationTypes() {
			return this.viewMode === 'short' ? this.preScores.communication_types_fast : this.preScores.communication_types_detail
		},
		completeFullStatus() {
			return this.formCompleteStatus('full')
		},
		accept: {
			get() {
				return this.getEstimateFormKey('accept')
			},
			set(value) {
				this.itemsSearch = '';
				this.setEstimateFormKey({key: 'accept', value: value});
				if (!this.isItemGoalSent) {
					this.sentYmEstimateGoal({itemId: value, isSubmit: false});
				}
				if (this.item_id) {
					this.item_id = ''
				}

				if(this.filteredItems.length === 1) {
					this.item_id = this.filteredItems[0].id
				}
			}
		},
		'courier_required': {
			get() {
				return this.getEstimateFormKey('courier_required')
			},
			set(value) {
				this.setEstimateFormKey({key: 'courier_required', value: value})
			}
		},
		'city': {
			get() {
				return this.getEstimateFormKey('city')
			},
			set(value) {
				this.setEstimateFormKey({key: 'city', value: value})
			}
		},
		'item_id': {
			get() {
				this.loadItemFields()
				return this.getEstimateFormKey('item_id')
			},
			set(value) {
				this.setEstimateFormKey({key: 'item_id', value: value})
				this.loadItemFields()
			}
		},
		'item_desc': {
			get() {
				return this.getEstimateFormKey('item_desc')
			},
			set(value) {
				this.setEstimateFormKey({key: 'item_desc', value: value})
			}
		},
		'max_loan': {
			get() {
				return this.getEstimateFormKey('max_loan') || ''
			},
			set(value) {
				this.setEstimateFormKey({key: 'max_loan', value: String(value)})
			}
		},
		'max_term': {
			get() {
				return this.getEstimateFormKey('max_term') || ''
			},
			set(value) {
				this.setEstimateFormKey({key: 'max_term', value: String(value)})
			}
		},
		photos: {
			get() {
				return this.getEstimateFormKey('photos')
			},
			set(value) {
				this.setEstimateFormKey({key: 'photos', value: value})
			}
		},
		name: {
			get() {
				return this.getEstimateFormKey('name')
			},
			set(value) {
				this.setEstimateFormKey({key: 'name', value: value})
			}
		},
		phone: {
			get() {
				return this.getEstimateFormKey('phone')
			},
			set(value) {
				this.setEstimateFormKey({key: 'phone', value: value})
			}
		},
		email: {
			get() {
				return this.getEstimateFormKey('email')
			},
			set(value) {
				this.setEstimateFormKey({key: 'email', value: value})
			}
		},
		'com_types': {
			get() {
				return this.getEstimateFormKey('com_types') || []
			},
			set(value) {
				this.setEstimateFormKey({key: 'com_types', value: value})
			}
		},
		courierAvailable() {
			return this.isCouerierAvailable(this.city) && window.location.hostname !== 'avtolombard-fianit.ru'
		},
		previewUrl() {
			return (photo) => URL.createObjectURL(photo)
		},
		filteredItems() {
			const items = this.acceptItems(this.accept);
			if (this.itemsSearch) return items.filter(item => item.name.toLowerCase().includes(this.itemsSearch.toLowerCase()))
			return items
		},
		shownItems() {
			return this.itemsShowMore ? this.filteredItems : this.filteredItems.slice(0, 6)
		},
		isCategoryNotFoundSelected() {
			return this.accept === CATEGORY_NOT_FOUND_ID;
		},
		...mapGetters({
			getUserData: 'user/getUserData',
			preScores: 'estimate/getPreScoreInitials',
			getEstimateFormKey: 'estimate/getEstimateFormKey',
			getEstimateFormTouch: 'estimate/getEstimateFormTouch',
			getEstimateFormFlag: 'estimate/getEstimateFormFlag',
			getViewMode: 'estimate/getPopupViewMode',
			acceptItems: 'estimate/getAcceptItems',
			acceptItemData: 'estimate/getAcceptItemData',
			getItemParamsKey: 'estimate/getItemParamsKey',
			formCompleteStatus: 'estimate/formCompleteStatus',
			itemParamsCompleteStatus: 'estimate/getItemParamsCompleteStatus',
			preScoreValues: 'estimate/getPreScoreValues',
			currentItemFields: 'estimate/getCurrentItemFields',
			documents: 'getDocuments',
			citiesList: 'location/getCitiesList',
			isCouerierAvailable: 'location/isCourierAvailable',
			isItemGoalSent: 'estimate/getEstimateItemGoalSentStatus',
		})
	},
	methods: {
		onOpenPhotoSearchModal() {
			this.openModal('popup-photo-search')
			window.fancyboxConstructor.close();
		},
		async sendForm() {

			this.loading = true
			const result = await this.highlightInputs();
			if (!result) {
				this.loading = false
				return
			}
			
			if(this.getNeedMlEstimate()) {
				const result = await this.requestPignusCreate({params: this.getEstimateFormKey('params'), photo: this.getEstimateFormKey('photos')})
				if(result.success) {
					this.setPignusId(result.data.orderId)
					this.openModal('estimate-pignus')
					window.fancyboxConstructor.close()
				} else {
					window.toast.error(result.message)
				}
				return this.loading = false
			} 
		

			let status = await this.sendEstimateForm({mode: this.viewMode})

			if (status.success) {
				if (this.viewMode === 'full') {
					window.sendYM('podrobnaya-ocenka');
					if (this.courier_required) {
						window.sendYM('neotlojka-podrobnaya-ocenka');
					}
				} else {
					if (this.courier_required) {
						window.sendYM('neotlojka-bystraya-ocenka');
					}
					window.sendYM('bystraya-ocenka');
				}

				this.v$.$reset()
				this.setSuccess({
					title: 'Спасибо за обращение! Заявка принята.',
					message: ` ${this.getEstimateFormKey('courier_required') ? 'Для подтверждения вызова курьера на дом, в течение часа с вами свяжется специалист службы оценки.' : 'Специалист службы оценки свяжется с Вами в течение часа.'}</br></br> Обработка заявок происходит с 09:00 до 21:00. Если заявка была оставлена Вами после 21:00, то с вами свяжутся в период с 9:00 до 11:00 следующего дня.`,
				})

			} else {
				this.setSuccess({
					title: 'Что-то пошло не так',
					message: status.message
				})
			}

			this.loading = false
			this.emptyFields = false
			this.showMore = false

			window.fancyboxConstructor.close()
			window.fancyboxConstructor.show([{src: "#popup-success", type: "inline"}], {
				Toolbar: false,
				dragToClose: false,
				Thumbs: false,
				closeButton: "top",
				mainClass: "fancybox-modal",
			})

		},

		getNeedMlEstimate() {
			const acceptanceItem = this.preScores.accept_types
				.find(t => t.id === Number(this.getEstimateFormKey('accept')))?.items
				.find(i => i.id === this.getEstimateFormKey('item_id'));
			const cityMlEstimate = this.citiesList.find(city => city.id === this.city)?.available_ml_estimate;
			
			return acceptanceItem?.isMlEstimate && cityMlEstimate
		},
		async highlightInputs() {
			const result = await this.v$.$validate()
			this.emptyFields = true
			this.$refs.contactBlock.scrollIntoView({
				block: "center",
				behavior: "smooth"
			});
			return result
		},
		setFiles(e) {
			let fileList = Array.from(e.target.files)
			fileList.filter((file) => file.size <= (this.preScores['files']['max_size'] * 1000))
			this.photos = this.photos.concat(fileList)
			if (this.photos.length > 10) {
				this.photos.length = 10
			}
		},
		onToggleShowWeightInput() {
			this.setItemParamsKey({key: 'weight', value: ''});
			this.setEstimateFormFlag({key: 'showWeightInput', value: !this.getEstimateFormFlag('showWeightInput')});
		},
		onSelectCategoryNotFound() {
			this.accept = CATEGORY_NOT_FOUND_ID;
			this.item_id = CATEGORY_NOT_FOUND_ITEM_ID;
		},

		isInputAllowed(item) {
			if (item.xml_id === 'manufacturer_id_other') {
				return this.getItemParamsKey('manufacturer_id') === 'Другое';
			} else if (item.xml_id === 'model_other') {
				return this.getItemParamsKey('model_list') === 'Другое';
			} else if (item.xml_id === 'new_manufacturer') {
				return this.getItemParamsKey('manufacturer_id') === 'Другое';
			} else if (item.xml_id === 'new_model') {
				return this.getItemParamsKey('model_list') === 'Другое';
			} else {
				return true;
			}
		},

		async onSelectValue(item, value) {
			this.setItemParamsKey({key: item.xml_id, value})
			if (item.xml_id === 'manufacturer_id' && value !== 'Другое') {
				const response = await this.requestPignusModels(value)
				if (response.success) {
					this.models = response.data;
				} else {
					this.models = ['Другое'];
				}
			}
		},

		...mapActions({
			requestUserData: 'user/requestUserData',
			loadPreScoreInitials: 'estimate/loadPreScoreInitials',
			sendEstimateForm: 'estimate/sendEstimateForm',
			loadPreScoreValues: 'estimate/loadPreScoreValues',
			loadItemFields: 'estimate/loadItemFields',
			sentYmEstimateGoal: 'estimate/sentYmEstimateGoal',
			openModal: 'modals/openModal',
			requestPignusModels: 'estimate/requestPignusModels',
			requestPignusCreate: 'estimate/requestPignusCreate',
		}),
		...mapMutations({
			setSuccess: 'setPopupSuccessData',
			setEstimateFormKey: 'estimate/setEstimateFormKey',
			setEstimateFormTouch: 'estimate/setEstimateFormTouch',
			setEstimateFormFlag: 'estimate/setEstimateFormFlag',
			setViewMode: 'estimate/setPopupViewMode',
			setDefaultItemParams: 'estimate/setDefaultItemParams',
			setItemParamsKey: 'estimate/setItemParamsKey',
			setPignusId: 'estimate/setPignusId'
		})
	}
}
</script>
